export default __webpack_public_path__ + "static/media/Graph_SMP-MediumToHigh.c7157cad.svg";